import React, { useEffect, useMemo, useState, useRef } from "react";
import { useAuthStore } from "../../../store/authStore";
import $ from "jquery";
import moment from "moment";
import "daterangepicker";
import "daterangepicker/daterangepicker.css";
import { api } from "../../../utils/api";
import { useLoaderStore } from "../../../store/loaderStore";
import {
  FiCheck,
  FiX,
  FiSearch,
  FiCheckSquare,
  FiSquare,
  FiClock,
  FiCalendar,
} from "react-icons/fi";

import { toast } from "react-toastify";

import "./Approvals.css";
import ApprovalPunchSummary, { approvalInitials } from "../../../components/mobile/ApprovalPunchSummary";
import "../../../components/mobile/ApprovalPages.css";
import RequestDetailsSheet from "../../../components/mobile/RequestDetailsSheet";
import "../../../components/mobile/MobileDatePicker.css";
import { alignPickerToFilter } from "../../../utils/mobileDatePicker";
import MobileLayout from "../../../layouts/MobileLayout";


const Approvals = () => {
  const { user, isAuthenticated } = useAuthStore();
  const companyId = user?.company_id;

  const [approvals, setApprovals] = useState([]);
  const [loading, setLoading] = useState(false);
  const { showLoader, hideLoader } = useLoaderStore();

  useEffect(() => {
    if (!loading) return undefined;

    showLoader("master");
    return () => hideLoader();
  }, [loading, showLoader, hideLoader]);

  const [actionLoading, setActionLoading] = useState(false);

  const [error, setError] = useState("");

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [selectedIds, setSelectedIds] = useState([]);

  const [selectedApproval, setSelectedApproval] = useState(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [detailsActionVisible, setDetailsActionVisible] = useState(false);

  const [remarks, setRemarks] = useState("");
  const [bulkRejectModalOpen, setBulkRejectModalOpen] = useState(false);
  const [bulkRejectRemark, setBulkRejectRemark] = useState("");

  const pickerRef = React.useRef(null);

  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD"),
  );

  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD"),
  );

  /* =====================================================
     FETCH APPROVALS
  ===================================================== */

  // const fetchApprovals = async (fromDate = startDate, toDate = endDate) => {
  //   if (!token || !companyId) return;

  //   try {
  //     setLoading(true);
  //     setError("");

  //     const params = new URLSearchParams({
  //       company_id: String(companyId),
  //       from_date: fromDate,
  //       to_date: toDate,
  //     });

  //     const response = await fetch(
  //       `${API_BASE_URL}/attendance/missing-punch/approvals?${params.toString()}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           Accept: "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       },
  //     );

  //     const result = await response.json();

  //     if (!response.ok) {
  //       throw new Error(
  //         result?.detail?.[0]?.msg ||
  //           result?.message ||
  //           "Failed to fetch pending approvals.",
  //       );
  //     }

  //     // Backend response is expected to contain the approval list.
  //     const data = Array.isArray(result)
  //       ? result
  //       : Array.isArray(result.data)
  //         ? result.data
  //         : [];

  //     setApprovals(data);
  //     setSelectedIds([]);
  //   } catch (err) {
  //     console.error("Fetch approvals error:", err);

  //     setError(err.message || "Failed to load approvals.");
  //     setApprovals([]);
  //     setSelectedIds([]);

  //     toast.error(err.message || "Failed to load approvals.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchApprovals = async (fromDate = startDate, toDate = endDate) => {
    if (!isAuthenticated || !companyId) return;

    try {
      setLoading(true);
      setError("");

      const params = new URLSearchParams({
        company_id: companyId,
        from_date: fromDate,
        to_date: toDate,
      });

      const response = await api.get(
        `/attendance/missing-punch/approvals?${params.toString()}`,
        {
          headers: {
            Accept: "application/json",
          },
        },
      );

      const result = await response.json();

      const data = Array.isArray(result)
        ? result
        : Array.isArray(result.data)
          ? result.data
          : [];

      setApprovals(data);
      setSelectedIds([]);
    } catch (err) {
      console.error("Fetch approvals error:", err);

      setError(err.message || "Failed to load approvals.");
      setApprovals([]);
      setSelectedIds([]);

      toast.error(err.message || "Failed to load approvals.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated && companyId) {
      fetchApprovals();
    }
  }, [isAuthenticated, companyId]);

  /* =====================================================
   DATE RANGE PICKER
===================================================== */

  useEffect(() => {
    if (!pickerRef.current) return;

    const $picker = $(pickerRef.current);

    // Remove existing picker if already initialized
    if ($picker.data("daterangepicker")) {
      $picker.data("daterangepicker").remove();
    }

    const cb = (start, end) => {
      const from = start.format("YYYY-MM-DD");
      const to = end.format("YYYY-MM-DD");

      setStartDate(from);
      setEndDate(to);

      // Fetch approvals immediately for selected range
      fetchApprovals(from, to);
    };

    $picker.daterangepicker(
      {
        startDate: moment(startDate),
        endDate: moment(endDate),

        autoUpdateInput: false,
        showDropdowns: true,
        linkedCalendars: false,
        alwaysShowCalendars: true,

        opens: "left",

        ranges: {
          Today: [moment(), moment()],

          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],

          "Last 7 Days": [moment().subtract(6, "days"), moment()],

          "Last 30 Days": [moment().subtract(29, "days"), moment()],

          "This Month": [moment().startOf("month"), moment().endOf("month")],

          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      },
      cb,
    );

    const picker = $picker.data("daterangepicker");
    picker.container.addClass("mobile-daterangepicker");
    const unalign = alignPickerToFilter(
      picker,
      pickerRef.current,
      pickerRef.current.closest(".admin-approvals-filter-bar"),
    );

    return () => {
      unalign();
      if ($picker.data("daterangepicker")) {
        $picker.data("daterangepicker").remove();
      }
    };
  }, []);

  /* =====================================================
     FORMAT DATE
  ===================================================== */

  const formatDate = (dateTime) => {
    if (!dateTime) return "-";

    const date = new Date(dateTime);

    if (Number.isNaN(date.getTime())) {
      return "-";
    }

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  /* =====================================================
     FORMAT TIME
  ===================================================== */

  const formatTime = (dateTime) => {
    if (!dateTime) return "-";

    const date = new Date(dateTime);

    if (Number.isNaN(date.getTime())) {
      return "-";
    }

    return date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  /* =====================================================
     DURATION
  ===================================================== */

  const getDuration = (inDateTime, outDateTime) => {
    if (!inDateTime || !outDateTime) {
      return "-";
    }

    const start = new Date(inDateTime);
    const end = new Date(outDateTime);

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      return "-";
    }

    const difference = end.getTime() - start.getTime();

    if (difference < 0) {
      return "-";
    }

    const totalMinutes = Math.floor(difference / 60000);

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}`;
  };

  /* =====================================================
     FILTER APPROVALS
  ===================================================== */

  const filteredApprovals = useMemo(() => {
    return approvals.filter((item) => {
      const searchValue = search.trim().toLowerCase();

      const matchesSearch =
        !searchValue ||
        String(item.user_name || "")
          .toLowerCase()
          .includes(searchValue) ||
        String(item.employee_code || "")
          .toLowerCase()
          .includes(searchValue) ||
        String(item.user_id || "")
          .toLowerCase()
          .includes(searchValue) ||
        String(item.id || "")
          .toLowerCase()
          .includes(searchValue);

      const matchesStatus =
        !statusFilter ||
        String(item.status || "").toLowerCase() === statusFilter.toLowerCase();

      return matchesSearch && matchesStatus;
    });
  }, [approvals, search, statusFilter]);

  /* =====================================================
     SELECT INDIVIDUAL
  ===================================================== */

  const toggleSelection = (id) => {
    setSelectedIds((previous) => {
      if (previous.includes(id)) {
        return previous.filter((itemId) => itemId !== id);
      }

      return [...previous, id];
    });
  };

  /* =====================================================
     SELECT ALL
  ===================================================== */

  const allFilteredSelected =
    filteredApprovals.length > 0 &&
    filteredApprovals.every((item) => selectedIds.includes(item.id));

  const toggleSelectAll = () => {
    if (allFilteredSelected) {
      setSelectedIds((previous) =>
        previous.filter(
          (id) => !filteredApprovals.some((item) => item.id === id),
        ),
      );
    } else {
      setSelectedIds((previous) => {
        const newIds = filteredApprovals
          .map((item) => item.id)
          .filter((id) => !previous.includes(id));

        return [...previous, ...newIds];
      });
    }
  };

  /* =====================================================
     OPEN DETAILS
  ===================================================== */

  const openDetails = (approval, withActions = false) => {
    setDetailsActionVisible(withActions);
    setSelectedApproval(approval);
    setRemarks(approval.remark || "");
    setModalOpen(true);
  };

  /* =====================================================
     CLOSE MODAL
  ===================================================== */

  const closeModal = () => {
    if (actionLoading) return;

    setModalOpen(false);
    setSelectedApproval(null);
    setRemarks("");
  };

  /* =====================================================
     APPROVE API
  ===================================================== */

  const approveApproval = async (approvalId, remark = "") => {
    if (!approvalId || !isAuthenticated || !companyId) {
      return false;
    }

    try {
      const params = new URLSearchParams({
        company_id: String(companyId),
      });

      const response = await api.post(
        `/attendance/missing-punch/approve?${params.toString()}`,
        {
          approval_ids: [approvalId],
          remark: remark || ""
        },
        { headers: { Accept: "application/json" } },
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result?.detail?.[0]?.msg ||
            result?.message ||
            "Failed to approve request.",
        );
      }

      return true;
    } catch (err) {
      console.error("Approve error:", err);
      throw err;
    }
  };

  /* =====================================================
     REJECT API
  ===================================================== */

  const rejectApproval = async (approvalId, remark = "") => {
    if (!approvalId || !isAuthenticated || !companyId) {
      return false;
    }

    try {
      const params = new URLSearchParams({
        company_id: String(companyId),
      });

      const response = await api.post(
        `/attendance/missing-punch/reject?${params.toString()}`,
        {
          approval_ids: [approvalId],
          remark: remark || ""
        },
        { headers: { Accept: "application/json" } },
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result?.detail?.[0]?.msg ||
            result?.message ||
            "Failed to reject request.",
        );
      }

      return true;
    } catch (err) {
      console.error("Reject error:", err);
      throw err;
    }
  };

  /* =====================================================
     APPROVE SINGLE
  ===================================================== */

  const handleApproveSingle = async (approval) => {
    if (!approval?.id) return;

    try {
      setActionLoading(true);

      await approveApproval(approval.id, "");

      toast.success(`Request #${approval.id} approved successfully.`);

      setApprovals((previous) =>
        previous.filter((item) => item.id !== approval.id),
      );

      setSelectedIds((previous) => previous.filter((id) => id !== approval.id));

      if (selectedApproval && selectedApproval.id === approval.id) {
        closeModal();
      }
    } catch (err) {
      toast.error(err.message || "Unable to approve request.");
    } finally {
      setActionLoading(false);
    }
  };

  /* =====================================================
     REJECT SINGLE
  ===================================================== */

  const handleRejectSingle = async (approval) => {
    if (!approval?.id) return;

    try {
      setActionLoading(true);

      await rejectApproval(approval.id, "");

      toast.success(`Request #${approval.id} rejected successfully.`);

      setApprovals((previous) =>
        previous.filter((item) => item.id !== approval.id),
      );

      setSelectedIds((previous) => previous.filter((id) => id !== approval.id));

      if (selectedApproval && selectedApproval.id === approval.id) {
        closeModal();
      }
    } catch (err) {
      toast.error(err.message || "Unable to reject request.");
    } finally {
      setActionLoading(false);
    }
  };

  /* =====================================================
     APPROVE FROM MODAL
  ===================================================== */

  const handleModalApprove = async () => {
    if (!selectedApproval?.id) return;

    try {
      setActionLoading(true);

      await approveApproval(selectedApproval.id, remarks);

      toast.success(`Request #${selectedApproval.id} approved successfully.`);

      setApprovals((previous) =>
        previous.filter((item) => item.id !== selectedApproval.id),
      );

      setSelectedIds((previous) =>
        previous.filter((id) => id !== selectedApproval.id),
      );

      closeModal();
    } catch (err) {
      toast.error(err.message || "Unable to approve request.");
    } finally {
      setActionLoading(false);
    }
  };

  /* =====================================================
     REJECT FROM MODAL
  ===================================================== */

  const handleModalReject = async () => {
    if (!selectedApproval?.id) return;

    // Manager remark is mandatory for rejection
    if (!remarks.trim()) {
      toast.warning("Manager remarks are mandatory when rejecting a request.");
      return;
    }

    try {
      setActionLoading(true);

      await rejectApproval(selectedApproval.id, remarks);

      toast.success(`Request #${selectedApproval.id} rejected successfully.`);

      setApprovals((previous) =>
        previous.filter((item) => item.id !== selectedApproval.id),
      );

      setSelectedIds((previous) =>
        previous.filter((id) => id !== selectedApproval.id),
      );

      closeModal();
    } catch (err) {
      toast.error(err.message || "Unable to reject request.");
    } finally {
      setActionLoading(false);
    }
  };

  /* =====================================================
     BULK APPROVE
  ===================================================== */

  const handleBulkApprove = async () => {
    if (selectedIds.length === 0) {
      toast.warning("Please select at least one request to approve.");
      return;
    }

    try {
      setActionLoading(true);

      const selectedApprovals = approvals.filter((item) =>
        selectedIds.includes(item.id),
      );

      const results = await Promise.allSettled(
        selectedApprovals.map((item) => approveApproval(item.id, "")),
      );

      const successfulIds = [];

      results.forEach((result, index) => {
        if (result.status === "fulfilled") {
          successfulIds.push(selectedApprovals[index].id);
        }
      });

      setApprovals((previous) =>
        previous.filter((item) => !successfulIds.includes(item.id)),
      );

      setSelectedIds((previous) =>
        previous.filter((id) => !successfulIds.includes(id)),
      );
    } catch (err) {
      console.error(err);
    } finally {
      setActionLoading(false);
    }
  };

  /* =====================================================
   BULK REJECT
===================================================== */

  const handleBulkReject = async () => {
    if (selectedIds.length === 0) {
      toast.warning("Please select at least one request to reject.");
      return;
    }

    // Remark is mandatory
    if (!bulkRejectRemark.trim()) {
      toast.warning("Manager remarks are mandatory when rejecting requests.");
      return;
    }

    try {
      setActionLoading(true);

      const params = new URLSearchParams({
        company_id: String(companyId),
      });

      const response = await api.post(
        `/attendance/missing-punch/reject?${params.toString()}`,
        {
          approval_ids: selectedIds,
          remark: bulkRejectRemark.trim()
        },
        { headers: { Accept: "application/json" } },
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result?.detail?.[0]?.msg ||
            result?.message ||
            "Failed to reject selected requests.",
        );
      }

      toast.success(
        `${selectedIds.length} request${
          selectedIds.length > 1 ? "s" : ""
        } rejected successfully.`,
      );

      // Remove rejected requests from the list
      setApprovals((previous) =>
        previous.filter((item) => !selectedIds.includes(item.id)),
      );

      // Clear selection
      setSelectedIds([]);

      // Close bulk reject popup
      setBulkRejectModalOpen(false);
      setBulkRejectRemark("");
    } catch (err) {
      console.error("Bulk reject error:", err);

      toast.error(err.message || "Unable to reject selected requests.");
    } finally {
      setActionLoading(false);
    }
  };

  /* =====================================================
     CHARACTER COUNT
  ===================================================== */

  const handleRemarksChange = (e) => {
    setRemarks(e.target.value.slice(0, 250));
  };

  const handleRemarksKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();

      handleModalReject();
    }
  };

  /* =====================================================
     RENDER
  ===================================================== */

  return (
    <MobileLayout>
      <div className={`admin-approvals-page approval-design ${selectedIds.length > 0 ? "approval-has-selection" : ""} ${!loading && filteredApprovals.length === 0 ? "approval-no-results" : ""}`}>
        {/* BULK REJECT MODAL */}
{bulkRejectModalOpen && (
  <div
    className="admin-approvals-modal approval-bulk-reject-dialog"
    onClick={() => {
      if (!actionLoading) {
        setBulkRejectModalOpen(false);
        setBulkRejectRemark("");
      }
    }}
  >
    <div
      className="admin-approvals-modal-content"
      onClick={(e) => e.stopPropagation()}
    >
      {/* HEADER */}
      <div className="admin-approvals-modal-header">
        <div>
          <h2 className="admin-approvals-modal-title">
            Reject Selected Requests
          </h2>

          <p className="admin-approvals-modal-user">
            {selectedIds.length} request
            {selectedIds.length > 1 ? "s" : ""} selected
          </p>
        </div>

        <button
          type="button"
          className="admin-approvals-modal-close"
          onClick={() => {
            setBulkRejectModalOpen(false);
            setBulkRejectRemark("");
          }}
          disabled={actionLoading}
        >
          <FiX />
        </button>
      </div>

      {/* BODY */}
      <div className="admin-approvals-modal-body">
        <div className="admin-approvals-manager-remark">
          <label className="admin-approvals-manager-remark-label">
            Manager Remarks{" "}
            <span style={{ color: "var(--accent-strong)" }}>*</span>
          </label>

          <textarea
            className="admin-approvals-remarks-textarea"
            placeholder="Enter reason for rejecting selected requests"
            value={bulkRejectRemark}
            onChange={(e) =>
              setBulkRejectRemark(e.target.value.slice(0, 250))
            }
            maxLength={250}
            autoFocus
          />

          <div className="admin-approvals-char-count">
            {bulkRejectRemark.length}/250
          </div>
        </div>
      </div>

      {/* ACTIONS */}
      <div className="admin-approvals-modal-actions">
        <button
          type="button"
          className="admin-approvals-modal-cancel"
          onClick={() => {
            setBulkRejectModalOpen(false);
            setBulkRejectRemark("");
          }}
          disabled={actionLoading}
        >
          Cancel
        </button>

        <button
          type="button"
          className="admin-approvals-modal-reject"
          onClick={handleBulkReject}
          disabled={actionLoading}
        >
          <FiX />
          {actionLoading ? "Rejecting..." : "Reject"}
        </button>
      </div>
    </div>
  </div>
)}
        {/* HEADER */}
        <div className="admin-approvals-header">
          <h1 className="admin-approvals-title">Approvals</h1>

          <p className="admin-approvals-summary">
            {filteredApprovals.length}/{approvals.length} Pending
          </p>
        </div>

        {/* FILTER */}
        <div className="admin-approvals-filter-bar">
          <div className="admin-approvals-filter-group">
            <label className="admin-approvals-filter-label">Search</label>

            <div className="admin-approvals-search-row">
              {/* SEARCH */}
              <div className="admin-approvals-search-wrapper">
                <FiSearch className="admin-approvals-search-icon" />

                <input
                  type="text"
                  className="admin-approvals-filter-input"
                  placeholder="Search by name, ID or code" aria-label="Search by name, ID or code"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

              {/* DATE RANGE */}
              <button type="button" ref={pickerRef} className="admin-approvals-date-range" aria-label="Choose date range">
                <span>
                  {moment(startDate).format("DD MMM")} -{" "}
                  {moment(endDate).format("DD MMM")}
                </span>

                <span className="admin-approvals-calendar-icon">
                  <FiCalendar />
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* SELECT ALL */}
        {!loading && (
          <div className="admin-approvals-select-all-wrapper">
            <label className="admin-approvals-select-all-label">
              <input
                type="checkbox"
                className="admin-approvals-select-all-checkbox"
                disabled={actionLoading || filteredApprovals.length === 0}
                checked={allFilteredSelected}
                onChange={toggleSelectAll}
              />

              <span>
                {allFilteredSelected ? <FiCheckSquare /> : <FiSquare />}
              </span>

              <span className="admin-approvals-select-all-text">
                Select All
              </span>
            </label>

            <span className="admin-approvals-selected-count">
              {selectedIds.length} selected
            </span>
          </div>
        )}

        {/* ERROR */}
        {error && <div className="admin-approvals-error">{error}</div>}

        {/* CONTENT */}
        <div className="admin-approvals-content">
          {/* EMPTY */}
          {!loading && filteredApprovals.length === 0 && (
            <div className="admin-approvals-empty">
              <div className="admin-approvals-empty-icon">
                <FiCheck />
              </div>

              <h3 className="admin-approvals-empty-title">
                No Pending Approvals
              </h3>

              <p className="admin-approvals-empty-text">
                There are no approval requests matching your search.
              </p>
            </div>
          )}

          {/* LIST */}
          {!loading && filteredApprovals.length > 0 && (
            <div className="admin-approvals-list">
              {filteredApprovals.map((approval) => {
                const isSelected = selectedIds.includes(approval.id);

                return (
                  <div
                    key={approval.id}
                    className={`admin-approval-card ${
                      isSelected ? "admin-approval-selected" : ""
                    }`}
                  >
                    {/* CARD TOP */}
                    <div className="admin-approval-card-top">
                      <div className="admin-approval-card-left">
                        <input
                          type="checkbox"
                          className="admin-approval-checkbox"
                          aria-label={`Select request from ${approval.user_name || "employee"}`}
                          checked={isSelected}
                          onChange={() => toggleSelection(approval.id)}
                        />

                        <div className="admin-approval-user-icon" aria-hidden="true">
                          {approvalInitials(approval.user_name || user?.name || user?.user_name)}
                        </div>

                        <div className="admin-approval-user-info">
                          <h3 className="admin-approval-user-name">
                            {approval.user_name || user?.name || user?.user_name || "Employee"}
                          </h3>

                          {/* <p className="admin-approval-user-code">
                          User ID: {approval.user_id} • Request #
                          {approval.id}
                        </p> */}
                        </div>
                      </div>

                      <span
                        className={`admin-approval-status ${
                          approval.status === "Approved"
                            ? "admin-approval-status-approved"
                            : approval.status === "Rejected"
                              ? "admin-approval-status-rejected"
                              : "admin-approval-status-pending"
                        }`}
                      >
                        {approval.status || "Pending"}
                      </span>
                    </div>

                    {/* DETAILS */}
                    <ApprovalPunchSummary
                      inDateTime={approval.in_datetime}
                      outDateTime={approval.out_datetime}
                    />

                    {/* ACTIONS */}
                    <div className="admin-approval-actions">
                      <button
                        type="button"
                        className="admin-approval-view-btn"
                        aria-label="View request details"
                        onClick={() => openDetails(approval)}
                      >
                        View
                      </button>

                      <button
                        type="button"
                        className="admin-approval-reject-btn"
                        disabled={actionLoading}
                        onClick={() => openDetails(approval, true)}
                      >
                        Reject
                      </button>

                      <button
                        type="button"
                        className="admin-approval-approve-btn"
                        disabled={actionLoading}
                        onClick={() => handleApproveSingle(approval)}
                      >
                        Approve
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* BULK ACTION BAR */}
        {selectedIds.length > 0 && !bulkRejectModalOpen && (
          <div className="admin-approvals-bulk-bar">
            <div className="admin-approvals-bulk-selection">
              <label className="admin-approvals-bulk-select-all">
                <input
                  type="checkbox"
                  checked={allFilteredSelected}
                  onChange={toggleSelectAll}
                  disabled={actionLoading || filteredApprovals.length === 0}
                />
                <span>Select All</span>
              </label>
              <span className="admin-approvals-bulk-text">
                {selectedIds.length} selected
              </span>
            </div>

            <button
              type="button"
              className="admin-approvals-bulk-reject-btn"
              disabled={actionLoading}
              onClick={() => {
                setBulkRejectRemark("");
                setBulkRejectModalOpen(true);
              }}
            >
              <FiX />
              Reject
            </button>

            <button
              type="button"
              className="admin-approvals-bulk-approve-btn"
              disabled={actionLoading}
              onClick={handleBulkApprove}
            >
              <FiCheck />
              Approve
            </button>
          </div>
        )}

        {/* DETAIL MODAL */}
        {modalOpen && selectedApproval && (
          <RequestDetailsSheet
            request={selectedApproval}
            onClose={closeModal}
            formatDate={formatDate}
            formatTime={formatTime}
            getDuration={getDuration}
            busy={actionLoading}
          >
            {detailsActionVisible && (
              <>
                <div className="admin-approvals-manager-remark">
                  <label className="admin-approvals-manager-remark-label">
                    Manager Remarks
                  </label>

                  <textarea
                    className="admin-approvals-remarks-textarea"
                    placeholder="Add your remarks "
                    value={remarks}
                    onChange={handleRemarksChange}
                    onKeyDown={handleRemarksKeyDown}
                    maxLength={250}
                  />

                  <div className="admin-approvals-char-count">
                    {remarks.length}/250
                  </div>
                </div>
              <div className="admin-approvals-modal-actions">
                <button
                  type="button"
                  className="admin-approvals-modal-cancel"
                  onClick={closeModal}
                  disabled={actionLoading}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="admin-approvals-modal-reject"
                  onClick={handleModalReject}
                  disabled={actionLoading}
                >
                  <FiX />
                  {actionLoading ? "Processing..." : "Reject"}
                </button>

                <button
                  type="button"
                  className="admin-approvals-modal-approve"
                  onClick={handleModalApprove}
                  disabled={actionLoading}
                >
                  <FiCheck />
                  {actionLoading ? "Processing..." : "Approve"}
                </button>
              </div>
              </>
            )}
          </RequestDetailsSheet>
        )}
      </div>
    </MobileLayout>
  );
};

export default Approvals;
